import React, { useState, useEffect, useRef } from "react";

import { trackPromise } from "react-promise-tracker";

import services from "../../services";

import {
  detalhesArquivo,
  editarArquivo,
  uploadImagem,
} from "../../services/http/arquivoServico";

import { listarPermissoes } from "../../services/http/usuariosService";

import { Modal, Checkbox, message } from "antd";

import IconeArquivos from "../IconeArquivos";

import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";

import "./styles.scss";
import ModalConfirmar from "../ModalConfirmar";
import { CloseOutlined } from "@mui/icons-material";
import { getIconesExtensao } from "../../services/utils";
import lang from "../../assets/idioma/idiomas";

const ModalEditarArquivo = ({ id, tipo, closeModal, openModal, buscar }) => {
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [permissoes, setPermissoes] = useState([]);
  const [arquivoPermissoes, setArquivoPermissoes] = useState([{}]);
  const [nomeArquivo, setNomeArquivo] = useState("");
  const [extensaoArquivo, setExtensaoArquivo] = useState("");
  const [dataVencimentoInicial, setDataVencimentoInicial] = useState("");
  const [dataVencimentoFinal, setDataVencimentoFinal] = useState("");
  const [horaInicial, setHoraInicial] = useState("");
  const [horaFinal, setHoraFinal] = useState("");
  const [pemissoesArquivo, setPermissoesArquivo] = useState([{}]);
  const [arquivo, setArquivo] = useState({});
  const [urlPreview, setUrlPreview] = useState("");
  const [dimensoes, setDimensoes] = useState("");

  const [segundoModal, setSegundoModal] = useState(false);
  const [checkAntes, setCheckAntes] = useState([]);
  const [checkDepois, setCheckDepois] = useState([]);
  const [modificar, setModificar] = useState(false);

  const refUploadPreview = useRef();

  useEffect(() => {
    buscarDetalhes();
  }, [id]);

  useEffect(() => {
    montarPermissoes();
  }, [permissoes]);

  const listaPermissoes = () => {
    trackPromise(
      listarPermissoes(true)
        .then((res) => {
          if (!res.fail && res.data) {
            setPermissoes(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const buscarDetalhes = () => {
    trackPromise(
      detalhesArquivo(id)
        .then((res) => {
          if (!res.fail && res.data) {
            setCheckAntes(res.data.permissoes);
            setNomeArquivo(res.data.nome);
            setExtensaoArquivo(res.data.extensao);

            if (res.data.dataVencimentoInicial) {
              let date1 = new Date(
                res.data.dataVencimentoInicial
              ).toLocaleDateString("fr-CA");
              setDataVencimentoInicial(date1);
              var hora1 = res.data.dataVencimentoInicial.substring(11, 16);
              setHoraInicial(hora1);
            }

            if (res.data.dataVencimentoFinal) {
              let date2 = new Date(
                res.data.dataVencimentoFinal
              ).toLocaleDateString("fr-CA");
              setDataVencimentoFinal(date2);
              var hora2 = res.data.dataVencimentoFinal.substring(11, 16);
              setHoraFinal(hora2);
            }

            setUrlPreview(res.data.urlPreview);
            setArquivo(res.data);
          }
        })
        .finally(() => {
          listaPermissoes();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const montarPermissoes = () => {
    setPermissoesArquivo([{}]);
    let novaListaPemissoes = [];

    if (arquivo.permissoes) {
      permissoes?.forEach((element) => {
        let permissao = arquivo.permissoes.findIndex((p) => p.id == element.id);

        novaListaPemissoes.push({
          id: element.id,
          permissao: element.permissao,
          checked: permissao >= 0 ? true : false,
        });
      });
      setPermissoesArquivo(novaListaPemissoes);
      setCheckDepois(novaListaPemissoes);
    } else {
      setPermissoesArquivo(permissoes);
    }
  };

  const editar = (idUsuarioOcultou) => {
    if (nomeArquivo.length > 0) {
      let arrayPermissoes = [];
      pemissoesArquivo.forEach((element) => {
        if (element.checked) {
          arrayPermissoes.push({
            id: element.id,
            permissao: element.permissao,
          });
        }
      });

      let data = {
        nomeArquivo: nomeArquivo,
        extensao: extensaoArquivo,
        idArquivo: id,
        idUsuarioOcultou: idUsuarioOcultou ? IdUser : null,
        permissoes: arrayPermissoes,
        urlPreview: urlPreview,
        dataVencimentoInicial: dataVencimentoInicial + " " + horaInicial,
        dataVencimentoFinal: dataVencimentoFinal + " " + horaFinal,
        dimensoes: dimensoes,
        autor: login,
      };

      if (dataVencimentoInicial == "" && horaInicial != "") {
        message.warning(lang.Informar_a_data_inicial);
        return;
      }

      if (dataVencimentoFinal == "" && horaFinal != "") {
        message.warning(lang.Informar_a_data_final);
        return;
      }

      if (data.dataVencimentoInicial === " ") {
        data.dataVencimentoInicial = null;
      }
      if (data.dataVencimentoFinal === " ") {
        data.dataVencimentoFinal = null;
      }

      if (
        data.dataVencimentoInicial !== null &&
        data.dataVencimentoFinal !== null
      ) {
        if (data.dataVencimentoFinal < data.dataVencimentoInicial) {
          message.warning(
            lang.A_data_inicial_nao_pode_ser_maior_que_a_data_final
          );
          return;
        }
      }

      if (
        data.dataVencimentoInicial === null &&
        data.dataVencimentoFinal !== null
      ) {
        message.warning(lang.Informar_a_data_inicial);
        return;
      }

      trackPromise(
        editarArquivo(data)
          .then((res) => {
            if (!res.fail) {
              message.success(lang.Arquivo_alterado_com_sucesso);
              buscar(nomeArquivo, 1);
              closeModal();
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else {
      message.warning(lang.Preencha_o_nome_do_arquivo);
      return;
    }
  };

  const handleCheckedPermissoes = (item, checked) => {
    if (item == "todos") {
      var arrayMap = arquivoPermissoes.map((item) => {
        return {
          id: item.id,
          permissao: item.permissao,
          checked: checked,
        };
      });
      setPermissoesArquivo(arrayMap);
    } else {
      let indexPermissao = pemissoesArquivo.findIndex((p) => p.id == item);

      if (indexPermissao >= 0) {
        pemissoesArquivo[indexPermissao].checked = checked;
        setPermissoesArquivo(pemissoesArquivo);
      }
    }
  };

  const uploadPreview = (e) => {
    trackPromise(
      uploadImagem(e.target.files[0])
        .then((res) => {
          if (!res.fail && res.data) {
            setUrlPreview(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleOpenUpload = () => {
    refUploadPreview.current.click();
  };
  useEffect(() => {
    if (modificar) {
      editar(null);
    }
  }, [modificar]);
  const formatNomePasta = (nome) => {
    if (nome.length > 20) {
      return nome.slice(0, 20) + "...";
    }
    return nome;
  };
  return (
    <div>
      <Modal
        visible={openModal}
        title={
          <span className="modal-title-editar-arquivo ">Editar arquivo</span>
        }
        className="modal-editar-pasta"
        closable={false}
        destroyOnClose={true}
        centered={false}
        footer={false}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <div className="">
          <div className="editar-visualizar w-100 d-flex justify-content-around">
            <input
              type="file"
              accept=".jpg,.jpeg,.png"
              ref={refUploadPreview}
              onChange={uploadPreview}
              style={{ display: "none" }}
            />
            <div className="editar-icone">
              {urlPreview == "" || urlPreview == null ? (
                <img width={"100%"} src={getIconesExtensao(arquivo.extensao)} />
              ) : (
                <img
                  width={"100%"}
                  height={"100%"}
                  src={urlPreview}
                  style={{
                    objectFit: "contain",
                  }}
                />
              )}
              <br />
              <div
                className="d-flex flex-column w-100"
                style={{ color: "#999" }}
              >
                <span>Proporção recomendada: 3:2 </span>
                <span>Exemplo: 300x200px</span>
              </div>
              <button onClick={handleOpenUpload}>Alterar o preview</button>
            </div>
            <div className="container-editar">
              <div className="group-input">
                <div className="label-input">
                  <label>Nome</label>
                  <br />
                  <input
                    className="input-nome"
                    onChange={(e) => setNomeArquivo(e.target.value)}
                    value={nomeArquivo}
                    placeholder="Nome completo do arquivo"
                  />
                </div>
              </div>
              <div className="group-input">
                <div className="label-input">
                  <label>Tipo</label>
                  <br />
                  {/* <input className="input-tipo" placeholder="Ícones" /> */}
                  <select
                    className="input-tipo"
                    value={extensaoArquivo}
                    onChange={(e) => {
                      setExtensaoArquivo(e.target.value);
                    }}
                    placeholder="Tipo do arquivo"
                  >
                    <option value=""></option>
                    <option value="ai">ai</option>
                    <option value="docx">docx</option>
                    <option value="eps">eps</option>
                    <option value="gif">gif</option>
                    <option value="icap">icap</option>
                    <option value="icma">icma</option>
                    <option value="icml">icml</option>
                    <option value="idap">idap</option>
                    <option value="idml">idml</option>
                    <option value="indb">indb</option>
                    <option value="indd">indd</option>
                    <option value="indl">indl</option>
                    <option value="indt">indt</option>
                    <option value="inx">inx</option>
                    <option value="jpeg">jpeg</option>
                    <option value="jpg">jpg</option>
                    <option value="mov">mov</option>
                    <option value="mp4">mp4</option>
                    <option value="otf">otf</option>
                    <option value="pdf">pdf</option>
                    <option value="png">png</option>
                    <option value="psb">psb</option>
                    <option value="psd">psd</option>
                    <option value="tif">tif</option>
                    <option value="ttf">ttf</option>
                    <option value="txt">txt</option>
                    <option value="xlsx">xlsx</option>
                    <option value="zip">zip</option>
                  </select>
                </div>
              </div>
              <div className="info-group-info">
                <div className="row">
                  <span className="editar-arquivo-span-title">Permissões</span>
                </div>
                <div className="editar-lista-permissoes">
                  {pemissoesArquivo.map((item, index) => {
                    return (
                      <div key={index}>
                        <Checkbox
                          defaultChecked={item.checked}
                          onChange={(e) =>
                            handleCheckedPermissoes(
                              `${item.id}`,
                              e.target.checked
                            )
                          }
                        >
                          {item.permissao}
                        </Checkbox>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="group-data-hora-arquivo">
              <div className="label-input">
                <div className="row w-100">
                  <div className="col-md-3">
                    <label className="mb-0">Data início</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      className="input-data-arquivo w-100"
                      type="date"
                      onChange={(e) => setDataVencimentoInicial(e.target.value)}
                      value={dataVencimentoInicial}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="mb-0">Hora início</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      className="input-hora-arquivo w-100"
                      type="time"
                      onChange={(e) => setHoraInicial(e.target.value)}
                      value={horaInicial}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="mb-0">Data fim</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      className="input-data-arquivo w-100"
                      type="date"
                      onChange={(e) => setDataVencimentoFinal(e.target.value)}
                      value={dataVencimentoFinal}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="mb-0">Hora fim</label>
                    <input
                      disabled={IsAdmin.toLocaleLowerCase() != "true"}
                      className="input-hora-arquivo w-100"
                      type="time"
                      onChange={(e) => setHoraFinal(e.target.value)}
                      value={horaFinal}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <hr className="divisao" />
          </div>

          <br />
          <div className="editar-buttons">
            <div className="div-button-cancelar-salvar">
              <button
                onClick={closeModal}
                className="editar-arquivo-button-publicar-mim-novo"
              >
                CANCELAR
              </button>

              <button
                className="editar-arquivo-button-publicar-todos-novo"
                onClick={() => setSegundoModal(true)}
              >
                SALVAR
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {segundoModal && (
        <ModalConfirmar
          segundoModal={segundoModal}
          setSegundoModal={setSegundoModal}
          checkAntes={checkAntes}
          checkDepois={checkDepois}
          setModificar={setModificar}
        />
      )}
    </div>
  );
};

export default ModalEditarArquivo;
